module.exports = __webpack_public_path__ + "static/media/cwpa.bcfeed62.png";